import ColorScheme from "color-scheme";

export default {
    methods: {
        generateColorPalette(amount) {
            const scheme = new ColorScheme();
            scheme
                .from_hue(21)
                .scheme("tetrade")
                .distance(1)
                .variation("pastel");
            var colors = scheme.colors();
            colors = colors.map(color => "#" + color);
            colors = this.shuffle(colors);
            return colors.slice(0, amount);
        },
        shuffle(array) {
            var currentIndex = array.length;
            var temporaryValue, randomIndex;

            // While there remain elements to shuffle...
            while (0 !== currentIndex) {
                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex -= 1;

                // And swap it with the current element.
                temporaryValue = array[currentIndex];
                array[currentIndex] = array[randomIndex];
                array[randomIndex] = temporaryValue;
            }
            return array;
        }
    }
};
